<template>
  <div class="login-page">
    <div class="login-container">
      <!-- Logo -->
      <div class="login-logo">
        <img :src="logo" alt="KES LAKAY" />
      </div>

      <!-- Login card -->
      <v-card class="login-card" flat>
        <v-card-text class="pa-8">
          <div class="text-center mb-6">
            <h1 class="login-title">Bienvenue</h1>
            <p class="login-subtitle">Connectez-vous à votre compte</p>
          </div>

          <v-form @submit.prevent="handleLogin">
            <v-text-field
              v-model="form.username"
              label="Nom d'utilisateur"
              outlined
              dense
              hide-details="auto"
              prepend-inner-icon="mdi-account-outline"
              class="mb-4"
              autocomplete="username"
            ></v-text-field>

            <v-text-field
              v-model="form.password"
              label="Mot de passe"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
              hide-details="auto"
              prepend-inner-icon="mdi-lock-outline"
              :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              @click:append="showPassword = !showPassword"
              class="mb-6"
              @keyup.enter="handleLogin"
              autocomplete="current-password"
            ></v-text-field>

            <v-btn
              color="primary"
              depressed
              block
              large
              :loading="loading"
              :disabled="loading || !form.username || !form.password"
              @click="handleLogin"
            >
              Se connecter
            </v-btn>
          </v-form>

          <v-alert
            v-if="login_errors"
            type="error"
            dense
            text
            class="mt-4 mb-0"
            dismissible
            @input="login_errors = false"
          >
            {{ error_message }}
          </v-alert>
        </v-card-text>
      </v-card>

      <!-- Footer -->
      <p class="login-footer">
        {{ new Date().getFullYear() }} &mdash; <strong>Kes Lakay</strong>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import logo from "../assets/img/emblem.png"

export default {
  name: 'LoginView',
  data: () => ({
    form: {
      username: "",
      password: "",
      serial_number: '000-0000-000-0000'
    },
    logo: logo,
    computerID_available: false,
    loading: false,
    showPassword: false,
    login_errors: false,
    error_message: "Vérifiez votre nom d'utilisateur et votre mot de passe puis réessayez."
  }),

  methods: {
    ...mapActions(["LogIn"]),

    async handleLogin() {
      if (!this.form.username || !this.form.password) return
      this.loading = true
      this.login_errors = false
      await this.submit()
    },

    async submit() {
      const User = new FormData()
      User.append("username", this.form.username)
      User.append("password", this.form.password)
      User.append("serial_number", this.form.serial_number)
      try {
        await this.LogIn(User)
        this.$router.push("/")
      } catch (error) {
        this.login_errors = true
        this.error_message = error?.response?.data?.message || "Échec de la connexion. Vérifiez votre nom d'utilisateur et votre mot de passe puis réessayez."
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  padding: 24px;
}

.login-container {
  width: 100%;
  max-width: 400px;
}

.login-logo {
  text-align: center;
  margin-bottom: 32px;
}

.login-logo img {
  width: 80px;
  height: auto;
}

.login-card {
  border-radius: 12px !important;
  border: 1px solid #e8ecf1;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;
}

.login-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a2332;
  margin-bottom: 4px;
}

.login-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

.login-footer {
  text-align: center;
  color: #94a3b8;
  font-size: 0.8125rem;
  margin-top: 24px;
}
</style>
